import fontawesome from "@fortawesome/fontawesome";
import { faGithub, faTwitter } from "@fortawesome/fontawesome-free-brands";
import {
  faTrash,
  faExclamation,
  faTimesCircle
} from "@fortawesome/fontawesome-free-solid";

fontawesome.library.add(
  faTrash,
  faExclamation,
  faTimesCircle,
  faGithub,
  faTwitter
);



// WEBPACK FOOTER //
// ./src/ui/FontAwesomeLibrary/index.js